import { useMemo } from 'react';

import { collection, Query, query } from 'firebase/firestore';

import { useCollectionData } from 'react-firebase-hooks/firestore';

import { useAuth } from '../contextProviders/AuthProvider';
import { firestore } from '../firebase';
import EmailTemplate from '../types/EmailTemplate';

/**
 * Fetches all email templates from the emailTemplates collection.
 * Only accessible by God users.
 */
export default function useEmailTemplates() {
  const { isGod } = useAuth();

  const templatesQuery = useMemo(() => {
    if (!isGod) return null;
    return query(collection(firestore, 'emailTemplates')) as Query<EmailTemplate>;
  }, [isGod]);

  const [templates, isTemplatesLoading, templatesError] = useCollectionData<EmailTemplate>(templatesQuery);

  return {
    templates: templates || null,
    isTemplatesLoading,
    templatesError,
  };
}
